import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

// reducers
import fileReducer from './file/slice';
import userReducer from './user/slice';
import tourReducer from './tour/slice';
import analyticsReducer from './analytics/slice';
import aiReducer from './ai/slice';

const rootReducer = combineReducers({
  user: userReducer,
  file: fileReducer,
  tours: tourReducer,
  analytics: analyticsReducer,
  ai: aiReducer
});

const persistConfig = {
  key: 'v1',
  blacklist: ['user', 'analytics'],
  storage
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
